import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from '../../../../avisos/criar-aviso/criar-aviso.component';
import { PlanoRefeicao } from '../../../../../models/PlanoRefeicao';
import { PlanoRefeicaoOpcao } from '../../../../../models/PlanoRefeicaoOpcao';

@Component({
  selector: 'app-adicionar-refeicao-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTimepickerModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './adicionar-refeicao-modal.html',
  styleUrl: './adicionar-refeicao-modal.scss',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideMomentDateAdapter(),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    provideNativeDateAdapter(),
  ],
})
export class AdicionarRefeicaoModal implements OnInit {
  refeicoes: string[] = [
    'Café da manhã',
    'Lanche da manhã',
    'Almoço',
    'Lanche da tarde',
    'Jantar',
    'Ceia',
    'Outra'
  ];

  refeicaoSelecionada: PlanoRefeicao = new PlanoRefeicao();
  refeicoesInativas: string[] = [];
  outraSelecionada: boolean = false;

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AdicionarRefeicaoModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.refeicoesInativas = this.data;

    this.form = this.fb.group({
      refeicao: ['', Validators.required],
      hora: ['', Validators.required],
      outra: ['']
    });

    this.form.get('refeicao')?.valueChanges.subscribe(value => {
      this.outraSelecionada = value === 'Outra';

      const outraControl = this.form.get('outra');

      if (this.outraSelecionada) {
        outraControl?.addValidators([Validators.required, Validators.minLength(5), Validators.maxLength(150)]);
      } else {
        outraControl?.clearValidators();
        outraControl?.setValue('');
      }

      outraControl?.updateValueAndValidity();
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  adicionar() {
    const refeicao = this.form.value;
    const opcao1: PlanoRefeicaoOpcao = new PlanoRefeicaoOpcao();
    opcao1.titulo = "Opção 1";

    let horarioStr = '';
    if (refeicao.hora instanceof Date) {
      const hours = refeicao.hora.getHours().toString().padStart(2, '0');
      const minutes = refeicao.hora.getMinutes().toString().padStart(2, '0');
      horarioStr = `${hours}:${minutes}`;
    }

    this.refeicaoSelecionada.horario = horarioStr;
    this.refeicaoSelecionada.nome = refeicao.refeicao;
    this.refeicaoSelecionada.nomePersonalizado = refeicao.outra;
    this.refeicaoSelecionada.opcoes = [opcao1];

    this.dialogRef.close(this.refeicaoSelecionada);
  }
}
